<template>
    <section class="sk-home__section sk-home__section--skeleton sk-home__faqs--skeleton kts-pt-50 kts-pt-mb-50 kts-pb-25 kts-pb-mb-25">
        <div class="sk-home__container">
            <div class="sk-home__heading">
                <h2 class="sk-home__heading-title"></h2>
            </div>
            <div class="sk-home__content sk-home__content--faqs kts-pt-30 kts-pt-mb-20">
                <div class="home-faqs__items">
                    <div class="home-faqs__item" v-for="item in resultFaqs">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup lang="ts">
    const resultFaqs = ref(4);
</script>